/* eslint-disable no-underscore-dangle */
import React from "react";

import { graphql } from "gatsby";

import Button from "cms/components/Button";
import { ButtonVariant } from "cms/components/Button/Button.styles";
import OptimizedImage from "cms/components/OptimizedImage";
import RichText from "cms/components/RichText";
import Text from "cms/components/Text";

import {
  Card,
  CardVariant,
  CardsContainer,
  Container,
  Content,
  Description,
  IconImageContainer,
  Link,
  Title,
} from "./CardsBlock.styles";

export interface CardsBlockProps extends Queries.SanityCardsBlock {}

const CardsBlock: React.FC<CardsBlockProps> = ({ title, cards }) => (
  <Container>
    <Content>
      {title && <Title>{title}</Title>}
      <CardsContainer>
        {cards?.map((card) => (
          <Card
            $variant={(card?.cardVariant as CardVariant) ?? "light"}
            key={card?.headline}
          >
            {card?.iconImage && (
              <IconImageContainer
                $variant={(card?.cardVariant as CardVariant) ?? "light"}
              >
                <OptimizedImage
                  image={card.iconImage}
                  alt={card.iconImageAlt}
                />
              </IconImageContainer>
            )}
            <Text variant="H3" as="h3" color="inherit">
              {card?.headline}
            </Text>
            {card?._rawDescription && (
              <Description>
                <RichText text={card?._rawDescription} />
              </Description>
            )}
            {card?.button?.url && card?.button?.label && (
              <Link href={card.button.url}>
                <Button
                  label={card.button.label}
                  variant={card.button.variant as ButtonVariant}
                />
              </Link>
            )}
          </Card>
        ))}
      </CardsContainer>
    </Content>
  </Container>
);

export const query = graphql`
  fragment CardsBlock on SanityCardsBlock {
    _key
    _type
    title
    cards {
      cardVariant
      iconImage {...OptimizedImage}
      iconImageAlt
      headline
      _rawDescription(resolveReferences: { maxDepth: 5 })
      button {
        label
        url
      }
    }
  }
`;

export default CardsBlock;
